/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState }  from "react"
import { ReactComponent as AddServiceIcon } from "../../../../../assets/Icons/IconPlusNV.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/Icons/IconDelete_KE.svg";
import { ReactComponent as BugIcon } from "../../../../../assets/Icons/IconBug.svg";
import { ReactComponent as BreakIcon } from "../../../../../assets/Icons/IconDisconnect.svg";
import { ReactComponent as MaintenanceIcon } from "../../../../../assets/Icons/IconMaintenance.svg";
import { ReactComponent as SwitchIcon } from "../../../../../assets/Icons/IconSwitch.svg";
import { useNavigate } from "react-router-dom";
import GenericAlert from "@ui-components/Alert/GenericAlert";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store/store";

export default function ConnectionDetailsTabs() {
      const navigate = useNavigate();
      const lag = useSelector((state: RootState) => state.port.lag);

      const dynamicServiceOptions = [
        "Add Connection",
        "Maintainance Mode",
        "Submit a Ticket",
        lag ? "Break LAG" : "Add LAG",
        "Disable Port",
        "Delete Port",
      ];
      const alertConfigs: Record<
        string,
        { title: string; description: string; confirmLabel: string; variant?: "confirm" | "success" | "error" | "warning" }
        > = {
        "Break LAG": {
          title: "Break LAG",
          description: "Are you sure you want to break the LAG? This might cause connection issues.",
          confirmLabel: "Yes, break it",
          variant: "warning",
        },
        "Add LAG": {
          title: "Add LAG",
          description: "No LAG is set up yet. Are you sure you want to add a new LAG configuration?",
          confirmLabel: "Yes, add it",
          variant: "confirm",
        },
        "Disable Port": {
          title: "Disable Port",
          description: "Are you sure you want to disable this port? This action is irreversible.",
          confirmLabel: "Yes, disable it",
          variant: "warning",
        },
        "Delete Port": {
          title: "Delete Port",
          description: "Are you sure you want to delete this port? All associated data will be lost.",
          confirmLabel: "Yes, delete it",
          variant: "error",
        },
      };

      const [alertState, setAlertState] = useState<{ isOpen: boolean; selection: string }>({
        isOpen: false,
        selection: "",
      });

      // Handlers for the selection inside the dropdown
      const handleServiceSelect = (selected: string) => {
        if (selected === "Add Connection") {
          // navigate("/kontrol/add-ipx");
        } else if (selected === "Submit a Ticket") {
          navigate("/request");
        } else if (["Break LAG", "Add LAG", "Disable Port", "Delete Port"].includes(selected)) {
          setAlertState({ isOpen: true, selection: selected });
        } else {
          console.warn("No route or action defined for this option:", selected);
        }
      };
        // Centralized handler for the alert's confirm action (pending this endpoints)
        const handleAlertConfirm = () => {
          switch (alertState.selection) {
            case "Break LAG":
              // dispatch(breakLagAction());
              break;
            case "Add LAG":
              // dispatch(addLagAction());
              break;
            case "Disable Port":
              // dispatch(disablePortAction());
              break;
            case "Delete Port":
              // dispatch(deletePortAction());
              break;
            default:
              console.warn("Unhandled alert action:", alertState.selection);
          }
          setAlertState({ isOpen: false, selection: "" });
        };
    
      //Helper to assign icons to each service Option
      const serviceIcons: Record<string, React.ReactNode> = {
        "Add Connection": <AddServiceIcon className="h-4 w-4 text-semantic-text-secondary" />,
        "Maintainance Mode": (
          <MaintenanceIcon className="h-4 w-4 text-semantic-text-secondary" />
        ),
        "Submit a Ticket": (
          <BugIcon className="h-4 w-4 text-semantic-text-secondary" />
        ),
        "Add LAG": (
          <AddServiceIcon className="h-4 w-4 text-semantic-text-secondary" />
        ),
        "Break LAG": (
          <BreakIcon className="h-4 w-4 text-semantic-text-secondary" />
        ),
        "Disable Port": <SwitchIcon className="h-4 w-4 text-semantic-text-secondary" />,
        "Delete Port": <DeleteIcon className="h-4 w-4 text-semantic-text-danger" />,
      };

    // Its menu is commented out until those flows exist; with no alert open there is
    // nothing to show, and an empty wrapper still cost the header a row of height.
    if (!alertState.isOpen) return null;

    return (
        <div
            className="
                flex
                justify-end
                w-full
                mt-1
            "
        >
            <div className="flex w-full justify-between">
                {/* <GenericButton
                    variant="secondary"
                    size="sm"
                    shape="ghost"
                    label="Manage Port Subscription"
                    icon={<SettingsIcon className="h-4 w-4 text-semantic-text-secondary" />}
                    // onClick={() => handleViewOrder(order)}
                /> */}
                {/* <GenericDropdown
                    items={dynamicServiceOptions}
                    defaultLabel=""
                    onSelect={handleServiceSelect}
                    icon={<DotsIcon className="h-4 w-4 text-semantic-text-secondary" />}
                    dropdownMaxWidthClass="w-[250px]"
                    position="right"
                    renderItem={(service) => (
                        <button
                          onClick={() => handleServiceSelect(service)}
                          className={`
                            w-full text-left px-3 py-2 flex items-center gap-2 text-sm 
                            text-semantic-text-secondary hover:bg-semantic-state-active 
                            hover:text-semantic-text-brand transition-colors
                            ${service === "Submit a Ticket" ? "border-b border-semantic-border-secondary" : ""}
                          `}
                        >
                          {serviceIcons[service]}
                          <span>{service}</span>
                        </button>
                      )}
                  /> */}
            </div>
            {alertState.isOpen && (
              <GenericAlert
                isOpen={alertState.isOpen}
                onClose={() => setAlertState({ isOpen: false, selection: "" })}
                onConfirm={handleAlertConfirm}
                title={alertConfigs[alertState.selection]?.title || "Warning"}
                description={alertConfigs[alertState.selection]?.description || ""}
                confirmLabel={alertConfigs[alertState.selection]?.confirmLabel || "Confirm"}
                cancelLabel="Cancel"
                variant={alertConfigs[alertState.selection]?.variant || "warning"}
              />
            )}
        </div>
    )
}
